module.exports = __webpack_public_path__ + "img/chocolade-cranberry-havermoutkoekjes.cd7b9ea8.jpg";